import React from 'react';

import { Icon, Row, Tooltip, TooltipPlacement } from 'farmhub-ui-core';

import {
  SyncStatusLoadingOutlineIcon,
  SyncStatusSuccessOutlineIcon,
} from 'components/Icon';
import { theme } from 'styled';

export default function LoadingProcessUpdateStatusChainOrder() {
  const [isLoadingFirst, setLoadingFirst] = React.useState<boolean>(false);
  const [totalProcessOrder, setTotalProcessOrder] = React.useState<number>(0);

  return (
    <Row styles={{ gap: 6 }} width="fit-content">
      {isLoadingFirst ? (
        <Tooltip placement={TooltipPlacement.Bottom} title="Đang đồng bộ">
          <Icon>
            <SyncStatusLoadingOutlineIcon height={18} width={18} />
          </Icon>
        </Tooltip>
      ) : (
        <>
          {totalProcessOrder != undefined && totalProcessOrder != 0 ? (
            <Tooltip placement={TooltipPlacement.Bottom} title="Đang đồng bộ">
              <Icon>
                <SyncStatusLoadingOutlineIcon height={18} width={18} />
              </Icon>
            </Tooltip>
          ) : (
            <Tooltip
              placement={TooltipPlacement.Bottom}
              title="Đồng bộ thành công"
            >
              <Icon>
                <SyncStatusSuccessOutlineIcon
                  color={theme.colors.success}
                  height={18}
                  width={18}
                />
              </Icon>
            </Tooltip>
          )}
        </>
      )}
    </Row>
  );
}
